<template>
  <v-col :cols="[this.$vuetify.breakpoint.smAndDown ? 6 : 3]">
    <v-hover v-slot:default="{ hover }">
      <v-card
        class="mx-auto"
        color="grey lighten-4"
        max-width="400"
      >
        <v-img
          :src="image"
          lazy-src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
          height="50vh"
        >
        <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular size="70" width="10" indeterminate color="black"></v-progress-circular>
            </v-row>
          </template>
          <v-expand-transition>
            <div
              v-if="!hover"
              class="d-flex transition-fast-in-fast-out darken-2 v-card--reveal subtitle-1 white--text"
              :class="color"
              style="height: 100%;"
            >
              <div style="position: absolute; top:5%;">
                {{deck}}
              </div>
              {{desc}}
            </div>
          </v-expand-transition>
        </v-img>
        <v-card-text
          class="pt-6"
          style="position: relative;"
        >
          <p class="subtitle-1 font-weight-light black--text mb-2">{{name}}</p>
        </v-card-text>
      </v-card>
    </v-hover>
  </v-col>
</template>

<script>
    export default {
      name: 'fapCard',
      props: {
        name: String,
        color: String,
        image: String,
        deck: String,
        desc: String
      },
      methods:{

      }
    }
</script>

<style>
    .v-card--reveal {
      align-items: center;
      bottom: 0;
      justify-content: center;
      opacity: .7;
      position: absolute;
      width: 100%;
    }
</style>